import React from 'react'
import {Form, FormGroup, ControlLabel, FormControl} from 'react-bootstrap'
import './style.css'
import classnames from 'classnames';
import {track, Control} from 'react-redux-form';
import Number from '../../common/form/spinner'

const ProductQuantity = ({id = 'qty', productState = '', showLabel = false, value = 0, handleChange, min}) => {

  return (
    <Form className={classnames('product-quantity-spinner', productState)} inline>
      <FormGroup controlId={'qty$' + id}>
        { showLabel &&
        <ControlLabel>Quantity</ControlLabel>
        }

        <Number min={min || 0}
                max={999}
                value={value}
                onChange={handleChange}/>

      </FormGroup>
    </Form>
  )
};

export default ProductQuantity;


// WEBPACK FOOTER //
// ./src/components/common/product/product-quantity.jsx